import { GridRow, OverflowText } from "designSystem/index";
import React from "react";
import { SlimCard, SlimCardProperties } from "./SlimCard";

interface SlimCardWithStatusProps extends SlimCardProperties {
	/* The status label on the right side of card */
	statusLabelRes?: string;
}

export const SlimCardWithStatus = (props: SlimCardWithStatusProps) => {
	const { statusLabelRes, textColor, ...otherProps } = props;

	return (
		<GridRow
			alignItems="center"
			growChild={0}
			pr={1}
		>
			<SlimCard
				textColor={textColor}
				{...otherProps} 
			/>
			<OverflowText 
				color={textColor} 
				res={statusLabelRes}
			/>
		</GridRow>
	);
};
